import React, { useRef, useEffect, useState } from "react";
import flvjs from 'flv.js'

// Styles
import styles from '../../index.module.css'
import Loading from "../../../../../Loading";

const CameraBox = ({ 
    onClick = () => {},
    url,
    isLive,
    controls = false
}) => {
    const videoRef = useRef(null)

    const [ loading, setLoading ] = useState(true)
    // const [ failed, setFailed ] = useState(false)

    useEffect(() => {
        if (!videoRef.current) return

        let flvPlayer;

        if (flvjs.isSupported() && url) {

            flvPlayer = flvjs.createPlayer({
                type: "flv",
                hasAudio: false,
                hasVideo: true,
                isLive: isLive,
                url: url,
            }, {
                enableStashBuffer: false,
            });
        
            flvPlayer.attachMediaElement(videoRef.current);
            setLoading(true);

            // !isLive && onClick(videoRef)
        
            flvPlayer.load();
            flvPlayer.play();

        }

        // const initPlayer = async () => {
        //     try {
        //         const res = await fetch(url);
        //         const contentType = res.headers.get("content-type");
            
        //         if (contentType && contentType.includes("application/json")) {
        //             setLoading(false)
        //             setFailed(true)

        //             return;
        //         }
        
        //     } catch (e) {
        //         setLoading(false);
        //         setFailed(true)
        //     }
        // };
        
        // !isLive && initPlayer();

        const handleCanPlay = () => setLoading(false);
        const videoElement = videoRef.current;
        if (videoElement) {
            videoElement.addEventListener("canplay", handleCanPlay);
        }
        
        return () => {
            if (flvPlayer) {
                flvPlayer.unload();
                flvPlayer.detachMediaElement();
                flvPlayer.destroy();
                flvPlayer = null;
            }
            if (videoElement) {
                videoElement.removeEventListener("canplay", handleCanPlay);
            }
        };
    

    }, [url]);

    return (
        <div className={styles['video-container']} onClick={() => onClick(videoRef)} aria-hidden='true'>
            {
                loading
                &&
                <Loading />
                // ||
                // (
                //     failed
                //     &&
                //     <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                //         <h3 style={{ color: 'white' }}>Video Loss</h3>
                //     </div>
                // )
                
            }
            <video
                style={{ width: "100%", height: 'inherit' }}
                ref={videoRef}
                muted
                controls={controls}
            >
                <track kind="captions" />
            </video>
        </div>
    );
    
}

  export default React.memo(CameraBox)